import { ExpandLess } from '@mui/icons-material';
import List from '@mui/material/List';
import styled from 'styled-components';

import { CommonButtonWrapper, LocalTabContent } from '@styles/CommonStyles';
import { colorTheme } from '@styles/muiTheme';

export const Wrapper = styled(List)<{ padding?: string }>(
  ({ padding }) => `
  background-color: ${colorTheme.palette.common.white};
  border: 1px solid ${colorTheme.palette.grey[500]};
  border-radius: 8px;
  padding: ${padding ? padding : '0'};
  max-height: 600px;
  overflow: auto;
`);

export const WrapperCollapseItem = styled.div`
  padding-left: 17px;
`;

export const StyledListItem = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0;
`;

export const StyledExpand = styled(ExpandLess)<{ isOpen: boolean }>(
  ({ isOpen }) => `
  position: absolute;
  top: 50%;
  left: 5px;
  transform:  translateY(-50%) ${isOpen ? 'rotate(0)' : 'rotate(180deg)'};
  font-size: 1.3rem;
  transition: .2s linear;
`,
);

export const ListItemText = styled.div`
  font-weight: 600;
  text-align: left;
  letter-spacing: 0px;
  color: #262626;
  margin-left: 12px;
`;

export const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-x: scroll;
  border-left: 1px solid #c9c9c9;
`;

export const ListItemButton = styled.div<{ disabled?: boolean }>(
  ({ disabled }) => `
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 12px 0 45px;
  cursor: ${disabled ? 'default' : 'pointer'};
  color: #262626;
  letter-spacing: 0;
  font-weight: 900;
  opacity: 1;
`,
);

// export const ListItemButton = styled.div`
// padding: 10px 12px 10px 20px;

export const PageContent = styled(LocalTabContent)`
  height: auto;
  min-height: 300px;
  width: 100%;
  padding-bottom: 60px;
`;

export const FormFooter = styled(CommonButtonWrapper)`
  position: relative;
`;
